import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Cookies from "js-cookie";
import Logo from "../Logo";

const ConfirmEmailPage = ({ setIsLoggedIn, setCurrentPage, setTitleDescription }) => {
  const navigate = useNavigate();
  const navigateToPage = (page) => {
    navigate(`/${page === 'feed' ? '' : page}`);
  };

  useEffect(() => {
    setTitleDescription("Fractofolio - Confirm Email", "The future of investment networking! Discover market insights, and make informed investment decisions with our community.")
  }, []);
  
  const [code, setCode] = useState("");

  const [confirmEmailStatus, setConfirmEmailStatus] = useState('');
  // const [disabledButton, setDisabledButton] = useState(false);
  const [successSendEmail, setSuccessSendEmail] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const ResendConfirmationCode = async () => {
    // setDisabledButton(true);
    setLoading(true);
    setSuccessSendEmail(false);
    setConfirmEmailStatus('');

    const data = {
      token: Cookies.get('token')
    }

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(apiURL+'/user/resend-confirm-email', data);
      if(response.data.status === 'ok') {
        setSuccessSendEmail(true);
      } else {
        setError(response.data.text);
      }
    } catch(e) {
      
    }
    
    // setDisabledButton(false);
    setLoading(false);
  };

  
  const ConfirmEmailRequest = async () => {
    setError("");
    setConfirmEmailStatus("");
    setLoading(true);

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const data = {
        email: Cookies.get('email'),
        emailToken: code
      }
      const response = await axios.post(`${apiURL}/user/confirm-email`, data);
      if(response.data.status === 'ok') {
        setConfirmEmailStatus('success');
      } else {
        setConfirmEmailStatus('failed');
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoading(false);
    }
  };

  function logOut() {
    Cookies.remove('token');
    Cookies.remove('email');
    router.push("/");
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <button onClick={() => navigateToPage('feed')} className="">
            <Logo textAlign="text-center" />
          </button>
          <h2 className="text-gray-700 text-2xl font-bold mt-5">Confirm your email</h2>
          <p className="text-gray-500 text-sm text-center">The email containing the confirmation link has been sent to your email address: If you have not received the email, please check your spam folder.</p>
        </div>

        {confirmEmailStatus !== 'success' && (
          <div className="linkedin-card">
            <div className="linkedin-card-content">
              <form className="space-y-4">

                {successSendEmail === true && (
                  <div className="mt-5 max-w-md sm:max-w-lg w-full bg-green-100 rounded-md p-3">
                    <p className="text-sm font-main-medium text-black">The email containing the confirmation link has been sent to your email address: <b>{Cookies.get('email')}</b></p>
                  </div>
                )}
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Confirmation code</label>
                  <input 
                    type="text" 
                    required 
                    className="linkedin-input"
                    placeholder="Confirmation code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  />
                </div>
                <button 
                  type="button"
                  className="linkedin-btn-primary w-full py-3"
                  onClick={() => ConfirmEmailRequest()}
                  disabled={loading}
                >
                  {loading === false && (
                    <span>Confirm Email</span>
                  )}
                  {loading === true && (
                    <span>Loading...</span>
                  )}
                </button>

                <div className="mx-auto w-fit">
                  <button 
                    type="button"
                    className="linkedin-btn-secondary py-3"
                    onClick={() => ResendConfirmationCode()}
                    disabled={loading}
                  >
                    {loading === false && (
                      <span>Resend Confirmation Code</span>
                    )}
                    {loading === true && (
                      <span>Loading...</span>
                    )}
                  </button>
                </div>

                {error != "" && (
                  <div className="mt-5 max-w-md sm:max-w-lg w-full bg-red-100 rounded-md p-3">
                    <p className="text-sm font-main-medium text-black">{error}</p>
                  </div>
                )}

              </form>
              
              <div className="mt-6 text-center border-t border-gray-200 pt-3">
                <div className="max-w-md sm:max-w-lg w-full mx-auto flex items-center justify-center font-main-medium cursor-pointer">
                  <p className="text-xs text-gray-500 text-center underline" onClick={() => logOut() }>
                    Log Out
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {confirmEmailStatus === 'success' && (
          <>
            <div className="mt-5 max-w-md sm:max-w-lg w-full bg-green-100 rounded-md p-3">
              <p className="text-sm text-center font-main-medium text-black">The email has been successfully confirmed.</p>
            </div>

            <span onClick={() => navigateToPage('feed') } className={`mt-4 max-w-md sm:max-w-lg w-full flex items-center justify-center bg-blue-600 text-white py-3 px-4 rounded-md hover:bg-blue-700 transition font-medium cursor-pointer`}>
              Open Website
            </span>
          </>
        )}

      </div>
    </div>
  );
};

export default ConfirmEmailPage;